<div class="notes-section">
  <div class="d-flex justify-content-between align-items-center mb-3">
    <h4>Notes & Description</h4>
    <button mat-raised-button color="accent" class="add-note-btn" (click)="openAddNoteDialog()" *ngIf="mode != 'view'">
      Add Note
    </button>
  </div>
  
  <!-- Loading state -->
  <div *ngIf="notesLoading" class="skeleton-box">
    <ngx-skeleton-loader [theme]="{height: '200px'}"></ngx-skeleton-loader>
  </div>
  
  <!-- Notes table -->
  <div *ngIf="!notesLoading && notes.length > 0" class="notes-table-container">
    <table class="table notes-table">
      <thead>
        <tr>
          <th>Notes & Description</th>
          <th>Captured by</th>
          <th>Time</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let note of notes">
          <td>
            <div class="note-content">
              <div class="note-main" *ngIf="note.note">
                <strong>{{ note.note }}</strong>
              </div>
              <div class="note-details" *ngIf="note.comments">
                {{ note.comments }}
              </div>
            </div>
          </td>
          <td>{{ note.createdByName || 'N/A' }}</td>
          <td>{{ formatDateTime(note.updateDate) }}</td>
          <td class="action">
            <button mat-icon-button color="primary" matTooltip="Edit Note" 
              (click)="openEditNoteDialog(note)" 
              *ngIf="mode != 'view' && canEditNote(note)">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button color="warn" matTooltip="Delete Note" 
            (click)="openDeleteNoteDialog(note)"
              *ngIf="mode != 'view' && canDeleteNote(note)">
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  
  <!-- No data state -->
  <div *ngIf="!notesLoading && notes.length === 0" class="no-data">
    <h4>No Notes Found</h4>
    <p>There are no notes available for this contract</p>
  </div>
</div>

